import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roomTypePipe'
})
export class RoomTypePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    let src: Map<number, string> = new Map([
      [1, "Camera singola"],
      [2, "Camera matrimoniale"],
      [3, "Camera tripla"],
      [4, "Camera quadrupla"],
    ])
    return (src.get(value)) || "";
  }

}